<template>
  <div class="menuBg">
    <scan-and-go
      v-if="
        (site_setting.scan_and_go_enabled || site_setting.coupons_enabled) &&
          show_scanandgo_modal
      "
      @couponScanned="couponScanned"
      @close="show_scanandgo_modal = false"
    ></scan-and-go>

    <div v-if="isDev" class="receipt-prototype">
      <pre
        v-for="(line, index) in receiptPrototype"
        :key="`${index}-${line}`"
        >{{ line }}</pre
      >
    </div>

    <div class="main-menu">
      <order-header :is-order="true" />
      <div class="listBlock">
        <div class="headerWrapper">
          <div class="headerTitle">
            {{ headerTitle }}
          </div>
          <div
            class="headerText"
            :class="{ 'headerText-v2': isV2EditOrder }"
            v-if="
              delivery_method.show_on_orderscreen &&
                !site_setting.coupons_enabled
            "
          >
            {{
              getTranslation(
                $store,
                "DeliveryMethod",
                "display_name",
                delivery_method.id,
                delivery_method.name
              )
            }}
          </div>
        </div>
        <div class="orderList">
          <order-list :noprices="project === 'elite'" @payOnEdit="pay" />
        </div>
        <total-amount></total-amount>
        <div class="btnBlock">
          <action-box
            v-if="delivery_method.identifier !== 'scan'"
            @click="toMenu"
            css-style="more"
          >
            {{ $t(`order.btn.more`) }}
          </action-box>
          <action-box
            v-if="basket.length > 0"
            @click="pay"
            css-style="pay"
            :disabled="payActionDisabled"
          >
            {{ $t("order.btn.to_pay") }}
          </action-box>
        </div>
      </div>
      <bottom-nav
        :noprices="project === 'elite'"
        :show-total-container="false"
        :show-scan-and-go="true"
        :show-submit="false"
        @proceed="pay"
        @showScanAndGoModal="showScanAndGoModal"
        >{{ $t("order.btn.to_pay") }}
      </bottom-nav>
    </div>
  </div>
</template>
<script>
import OrderHeader from "@/components/order/OrderHeader.vue";
import OrderList from "@/components/order/OrderList.vue";
import BottomNav from "@/components/BottomNav.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  findSameBasketItem,
  getOffer,
  productToBasketItem,
  combineProductsToMenu,
  addProductToBasket
} from "@/utils/products";
import { getTranslation } from "@/utils/helpers";
import { totalPrice, totalPriceValid } from "@/utils/pricing";
import ScanAndGo from "../components/modals/scanandgo";
import ActionBox from "@/components/ActionBox";
import TotalAmount from "@/components/TotalAmount";
import api from "@/api/orderkiosk";
import { isTableTentMode } from "@/utils/wbsIntegration";
import { isV2EditOrder } from "@/utils/templateSettings";
import { getReceiptPrototype } from "@/utils/vat";

export default {
  components: {
    ScanAndGo,
    OrderHeader,
    OrderList,
    BottomNav,
    ActionBox,
    TotalAmount
  },
  data() {
    return {
      show_scanandgo_modal: false
    };
  },
  created() {
    if (this.basket.length === 0) {
      if (this.delivery_method && this.delivery_method.identifier === "scan") {
        this.show_scanandgo_modal = true;
      } else {
        this.logRouter({ name: "menu", router: this.$router });
      }
    }
  },
  computed: {
    isDev() {
      return process.env.NODE_ENV === "development";
    },
    receiptPrototype() {
      return getReceiptPrototype(this.basket, this.coupons);
    },
    isV2EditOrder,
    payActionDisabled() {
      return !totalPriceValid(this.basket, this.coupons);
    },
    headerTitle() {
      return (
        this.$t(`order.header.title_1`) + " " + this.$t(`order.header.title_2`)
      );
    },
    offerProducts() {
      const offer = getOffer(this.offers, "MAKE_MENU_COMPLETE", this.schedules);
      if (!offer || offer.length === 0) return [];
      const products_ids = offer.products.map(elem => elem.id);
      let filtered_products = this.products_filtered.filter(
        item => products_ids.indexOf(item.id) !== -1
      );
      let filters = offer.filters.map(filter_id =>
        this.product_filters.find(el => el.id === filter_id)
      );
      //Order is irrelevant anyway since we only remove from the list.
      filters.sort((f1, f2) => {
        return f2.order_by - f1.order_by;
      });
      for (let idx = 0; idx < filters.length; idx++) {
        let filter = filters[idx];
        let fn = new Function("return " + filter.code)();
        filtered_products = fn(filtered_products, this.$store);
      }
      if (filtered_products.length === 0) {
        //basically offer all if nothing matches anymore.
        filtered_products = this.products.filter(
          item => products_ids.indexOf(item.id) !== -1
        );
      }
      return filtered_products;
    },
    sumPrice() {
      return totalPrice(this.basket);
    },
    ...mapGetters({
      basket: "BASKET",
      coupons: "COUPONS",
      offers: "OFFERS",
      schedules: "SCHEDULES",
      project: "PROJECT",
      products: "PRODUCTS",
      products_filtered: "PRODUCTS_FILTERED_BY_CATEGORY",
      delivery_method: "DELIVERY_METHOD_FULL",
      product_filters: "PRODUCT_FILTERS",
      site_setting: "SITE_SETTING",
      menus: "MENUS",
      isNumpadActive: "IS_NUMPAD_ACTIVE"
    })
  },
  methods: {
    showScanAndGoModal() {
      this.show_scanandgo_modal = true;
    },
    getTranslation,
    couponScanned(coupon) {
      console.log("Order: coupon scanned.");
      if (coupon.item) {
        let newBasket = this.basket.map(bi => {
          if (bi.uid === coupon.item) {
            return { ...bi, coupon };
          }
          return bi;
        });
        this.setBasket(newBasket);
        return;
      }
      //TODO: Apply coupon stuff to order, add to vuex
      this.add_coupon(coupon);
    },
    toMenu() {
      this.logRouter({ name: "menu", router: this.$router });
    },
    addBasket(item) {
      let basketItem = productToBasketItem(item);
      let newBasket = addProductToBasket(basketItem, this.basket);
      newBasket = combineProductsToMenu(this.menus, newBasket);
      this.setBasket(newBasket);
      this.logAudit({
        category: "CART",
        event: "ADD_PRODUCT",
        data: item
      });
    },
    pay() {
      let data = {
        basket: [...this.basket],
        delivery_method: this.delivery_method
      };
      api.getPuckOperation(data).then(r => {
        this.setPuckMode(r.data.puckMode);
        console.log("this.isNumpadActive = " + this.isNumpadActive);
        if (r.data.puckNeeded && this.isNumpadActive) {
          //TODO refactor setNextPuck call (add reset method?)
          this.setNextPuck({});
          this.logRouter({ name: "numpad", router: this.$router });
        } else if (isTableTentMode(this.delivery_method.identifier)) {
          this.logRouter({ name: "numpad", router: this.$router });
        } else {
          this.logRouter({ name: "checkout", router: this.$router });
        }
      });
    },
    ...mapMutations({
      setCurrentCategory: "SET_CURRENT_CATEGORY",
      setBasket: "SET_BASKET",
      add_coupon: "ADD_COUPON",
      setNextPuck: "SET_NEXT_PUCK",
      setPuckMode: "SET_PUCK_MODE"
    }),
    ...mapActions({ logRouter: "LOG_ROUTER", logAudit: "LOG_AUDIT" })
  }
};
</script>
<style lang="scss" scoped>
.receipt-prototype {
  position: absolute;
  top: 2rem;
  left: 0;
  background: #fffe;
  z-index: 9999;
  font-size: 20px;
  padding: 1rem;
  margin: 1rem;

  pre {
    margin: 0;
    min-height: 1.5em;
  }
}

.listBlock {
  display: flex;
  flex-direction: column;
  gap: 50px;
  padding-inline: 35px;
}

.menuBg {
  background: var(--page_Order_menuBg_background);
}

.orderList {
  position: relative;
  z-index: 5;
}

.offer {
  height: 300px;
  display: flex;
  /* justify-content: center; */
  text-align: center;
  flex-direction: column;
  align-items: center;
}

.offerText {
  font-family: var(--component_Order_offerText_font-family);
  font-size: var(--component_Order_offerText_font-size);
  text-transform: uppercase;
  margin-bottom: 50px;
}

.bots {
  height: 270px;
  background: rgb(84, 84, 84);
}

.btnBlock {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

@keyframes wobble {
  20% {
    transform: scale(1.05);
  }
  40% {
    transform: scale(0.95);
  }
  60% {
    transform: scale(1.07);
  }
  80% {
    transform: scale(1);
  }
}

.wobble {
  animation: wobble 2s infinite ease-in-out;
  transform-origin: 50% 50%;
}

.headerWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-block: 70px;
  /*z-index: 10;*/
}

.headerTitle {
  text-align: center;

  position: var(--page_Order_headerTitle_position);
  top: var(--page_Order_headerTitle_top);
  color: var(--page_Order_headerTitle_color);

  font-size: var(--page_Order_headerTitle_font-size);
  font-family: var(--page_Order_headerTitle_font-family);
  text-shadow: var(--page_Order_headerTitle_text-shadow);

  text-transform: var(--page_Order_headerTitle_text-transform);
  transform: var(--page_Order_headerTitle_transform);
  margin: var(--page_Order_headerTitle_margin);
}
.headerText {
  font-size: var(--page_Order_headerText_font-size);
  font-family: var(--page_Order_headerText_font-family);
  color: var(--page_Order_headerText_color);
  text-transform: var(--page_Order_headerText_text-transform);
  &:before {
    content: "-";
  }
  &:after {
    content: "-";
  }
}
.headerText-v2 {
  &:before {
    content: "";
  }
  &:after {
    content: "";
  }
}
</style>
